export const id_establishment_default = process.env
  .REACT_APP_PARCELAMOS_TUDO_ESTABLISHMENT as string;
